import React from 'react';
import logo from '../../../assets/images/products/shopping_logo.png'

export const Tab = ({ tabId, tabTitle, tabImage, tabText, tabLink, tabIcon, active, type, clicked, screenShot, buttonText, tabCategory, tabRow1, tabRow2, tabRow3, tabRow4, style }) => {
	const activeKey = active ? 'active-btn' : '';
	const activeValue = active ? 'active-tab' : '';
	if (type === 'key') {
		return (
			<li className={`tab-btn ${activeKey}`} data-tab={`#${tabId}-tab`} style={style}>{tabTitle}</li>
		);
	}

	return (
		<div className={`price-column pr-tab ${activeValue}`} id={`${tabId}-tab`}>
			<div className='col-inner'> {/*style={backgroundImage}*/}
				<div className="plan-title">{tabTitle}</div>
				<div className="duration">{tabCategory}</div>
				<img style={{ width: '75px', marginTop: '25px', marginBottom: '25px'}} src={require(`../../../assets/images/products/${tabIcon}`)} />
				<ul className="specs-list">
					<li>{tabRow1}</li>
					<li>{tabRow2}</li>
					<li>{tabRow3}</li>
					<li>{tabRow4}</li>
				</ul>
				<a className='theme-btn btn-style-three' onClick={clicked}>
					{buttonText}
				</a>
			</div>
		</div>
	);
};

{/*<div className='plan-title'>{tabTitle}</div>*/}
{/*<div className='duration'>{tabText}</div>*/}
{/*<div className='price'>$9<sup>.99</sup></div>*/}
{/*<ul className='specs-list'>*/}
{/*<li>50GB Bandwidth</li>*/}
{/*</ul>*/}



// WEBPACK FOOTER //
// ./src/components/ui/Tabs/Tab.js